import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, Box, DialogActions, DialogContent, Select, MenuItem, DialogTitle, OutlinedInput, Grid, Typography } from '@mui/material';

const ThreshHold = ({ open, onClose, onAction, }) => {
    return (
        <Dialog open={open} maxWidth={"xs"} onClose={onClose} >
            <Box sx={{ padding: 2, position: "relative", width: 400 }}>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} position={"relative"}>
                    <DialogTitle sx={{ fontSize: 24, padding: 1, fontWeight: 600, textAlign: "center" }}>Set threshold</DialogTitle>
                    <div onClick={onClose} className='absolute top-0 right-0 bg-black rounded-full h-5 w-5 flex items-center justify-center bg-opacity-80 cursor-pointer'>
                        <CloseIcon sx={{ color: "white", fontSize: 16 }} />
                    </div>
                </Box>
                <DialogContent sx={{ paddingX: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <OutlinedInput
                                fullWidth
                                size='small'
                                value={20}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <Select
                                fullWidth
                                size='small'
                                value="Kg"
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            overflowY: 'auto',
                                        },
                                    },
                                }}
                            >
                                {["Kg", "Tones"].map((lookup, __) => (
                                    <MenuItem key={lookup.title} value={lookup}>{lookup}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>

                    <Typography sx={{ mt: 2 }}>You will be informed via notification if the quantity goes below this</Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        onClick={() => { onClose(); onAction() }}
                        autoFocus
                        variant="contained"
                        sx={{ color: "white", width: "100%", height: 45 }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};


export default ThreshHold